import * as d3 from "d3";
import { useCallback, useEffect, useMemo, useRef } from "react";
import { useCurrentLanguage } from "../../../hooks/useCurrentLanguage";
import TEXT from "../../../utils/text/prensa.json";
import useWindowDimensions from "../utils/useWindoeDimensions";
const data = [
  { id: "transito", value: Math.round(14.09) },
  { id: "empleo", value: Math.round(8.38) },
  { id: "politicas", value: Math.round(37.78) },
  { id: "servicios", value: Math.round(11.12) },
  { id: "seguridad", value: Math.round(28.62) },
].sort((a, b) => (a.value < b.value ? -1 : 1)); // es necesario que esté ordenada por value

const topics = {
  empleo: { name: "Empleo", color: "green" },
  servicios: { name: "Servicios", color: "blue" },
  transito: { name: "Tránsito", color: "yellow" },
  seguridad: { name: "Seguridad", color: "dark-blue" },
  politicas: { name: "Políticas", color: "purple" },
};
export function StepBubbles({ currentStepIndex, stepBubbles, progress }) {
  const refContainer = useRef();
  const refBubblesContainer = useRef();
  const { width: windowWidth } = useWindowDimensions();

  const widthContainer =
    refContainer.current?.offsetWidth && refContainer.current?.offsetWidth !== 0
      ? refContainer.current?.offsetWidth
      : 0;
  const heightContainer =
    refContainer.current?.offsetHeight &&
    refContainer.current?.offsetHeight !== 0
      ? refContainer.current?.offsetHeight
      : 0;
  const bubblesContainerHeight =
    refBubblesContainer.current?.offsetHeight &&
    refBubblesContainer.current?.offsetHeight !== 0
      ? refBubblesContainer.current?.offsetHeight
      : 0;
  const maxBubble = bubblesContainerHeight + (windowWidth < 768 ? -100 : 200);
  // widthContainer > bubblesContainerHeight
  //   ? bubblesContainerHeight + (windowWidth < 768 ? -100 : 200)
  //   : widthContainer; // representa el 100% de los values
  const getBubbleSize = useCallback(
    (id) => {
      const value = (maxBubble * data.find((elm) => elm.id === id).value) / 100;
      const fontSize = 18; // font size inside bubbles
      return value < fontSize ? 25 : value;
    },
    [maxBubble]
  );
  const bubblesSize = useMemo(() => {
    return {
      seguridad: getBubbleSize("seguridad"),
      transito: getBubbleSize("transito"),
      politicas: getBubbleSize("politicas"),
      empleo: getBubbleSize("empleo"),
      servicios: getBubbleSize("servicios"),
    };
  }, [getBubbleSize]);
  let sumSizes = 0;
  data.forEach((elm) => (sumSizes += bubblesSize[elm.id]));
  const marginBetweenBubblesX = (widthContainer - sumSizes) / 5;
  const totalHeight = heightContainer;
  const initBubblesY =
    (totalHeight > 560 ? totalHeight + 50 : totalHeight) -
    bubblesContainerHeight;
  const wordsMargin = (widthContainer - 50 - 200 * 3) / 2;
  const wordsWidthSpace = widthContainer - 50;
  const wordsPosition = {
    politicas: (25 * 100) / wordsWidthSpace + 10,
    seguridad: ((25 + 200 + wordsMargin) * 100) / wordsWidthSpace,
    transito: ((25 + 200 * 2 + wordsMargin * 2) * 100) / wordsWidthSpace - 10,
  };

  useEffect(() => {
    function getPositionX(id) {
      const elmIndex = data.findIndex((elm) => elm.id === id);
      let position = windowWidth < 768 ? 10 : 50; //initial padding;
      for (let i = 0; i < elmIndex; i++) {
        position += bubblesSize[data[i].id] + marginBetweenBubblesX;
      }
      return position;
    }

    function getPositionY(id) {
      const space = windowWidth < 768 ? 1 : 2;
      const elmIndex = data.findIndex((elm) => elm.id === id);
      let position =
        initBubblesY +
        (windowWidth < 768
          ? -(totalHeight - bubblesContainerHeight - 100)
          : windowWidth > 1440
          ? -200
          : -85); //initial padding;
      for (let i = 0; i < elmIndex; i++) {
        position += bubblesSize[data[i + 1].id] / space;
      }
      return 100 - (position * 100) / totalHeight;
    }
    const bubblesPositionX = {
      seguridad: getPositionX("seguridad"),
      transito: getPositionX("transito"),
      politicas: getPositionX("politicas"),
      empleo: getPositionX("empleo"),
      servicios: getPositionX("servicios"),
    };
    const bubblesPositionY = {
      seguridad: getPositionY("seguridad"),
      transito: getPositionY("transito"),
      politicas: getPositionY("politicas"),
      empleo: getPositionY("empleo"),
      servicios: getPositionY("servicios"),
    };

    const bubblePolitica = d3.select("#politica");
    const bubbleSeguridad = d3.select("#seguridad");
    const bubbleTransito = d3.select("#transito");
    const pSeguridad = d3.select("#seguridad>p.label");
    const pPolitica = d3.select("#politica>p.label");
    const pTransito = d3.select("#transito>p.label");
    const pValueSeguridad = d3.select("#seguridad>p.value");
    const pValuePolitica = d3.select("#politica>p.value");
    const pValueTransito = d3.select("#transito>p.value");
    const bubbleEmpleo = d3.select("#empleo");
    const bubbleServicios = d3.select("#servicios");
    const pServicios = d3.select("#servicios>p");
    const pEmpleo = d3.select("#empleo>p");
    const bubblesTop = (initBubblesY * 100) / totalHeight - 10;
    moveBubbles();
    function moveBubbles() {
      switch (currentStepIndex) {
        case stepBubbles:
          return (
            [
              bubbleEmpleo,
              bubbleServicios,
              bubbleSeguridad,
              bubblePolitica,
              bubbleTransito,
            ].map((elm) =>
              elm.style("width", "0").style("height", "0").style("opacity", "0")
            ),
            [
              pValueSeguridad,
              pValuePolitica,
              pValueTransito,
              pEmpleo,
              pServicios,
            ].map((elm) => elm.style("font-size", "0"))
          );
        case stepBubbles + 1:
          return (
            bubblePolitica
              .style("top", `${bubblesTop}%`)
              .style("left", `${wordsPosition.politicas}%`)
              .transition()
              .transition()
              .style("opacity", "0"),
            pPolitica.transition().style("font-size", "0"),
            bubbleSeguridad
              .style("top", `${bubblesTop}%`)
              .style("left", `${wordsPosition.seguridad}%`)
              .transition()
              .style("opacity", "0"),
            pSeguridad.transition().style("font-size", "0"),
            bubbleTransito
              .style("top", `${bubblesTop}%`)
              .transition()
              .style("opacity", "0"),
            pTransito.transition().style("font-size", "0"),
            [
              pValueSeguridad,
              pValuePolitica,
              pValueTransito,
              pEmpleo,
              pServicios,
            ].map((elm) => elm.style("font-size", "0")),
            [bubbleEmpleo, bubbleServicios].map((elm) =>
              elm
                .style("width", "0")
                .style("height", "0")
                .style("top", `${bubblesTop}%`)
            )
          );
        case stepBubbles + 2:
          // step en el que aparecen los principales temas
          return (
            bubblePolitica
              .style("left", `${wordsPosition.politicas}%`)
              .style(
                "top",
                `${windowWidth < 768 ? bubblesTop + 10 : bubblesTop}%`
              )
              .transition()
              .style("opacity", "1")
              .style("width", "fit-content")
              .style("height", "fit-content"),
            pPolitica
              .transition()
              .style("font-size", "18px")
              .style("padding", "2px 5px"),
            bubbleSeguridad
              .style("left", `${wordsPosition.seguridad}%`)
              .style(
                "top",
                `${windowWidth < 768 ? bubblesTop + 20 : bubblesTop}%`
              )
              .transition()
              .delay(500)
              .style("opacity", "1")
              .style("width", "fit-content")
              .style("height", "fit-content"),
            pSeguridad
              .transition()
              .delay(500)
              .style("font-size", "18px")
              .style("padding", "2px 5px"),
            bubbleTransito
              .style(
                "top",
                `${windowWidth < 768 ? bubblesTop + 30 : bubblesTop}%`
              )
              .style("left", `${wordsPosition.transito}%`)
              .transition()
              .delay(700)
              .style("opacity", "1")
              .style("width", "fit-content")
              .style("height", "fit-content"),
            pTransito
              .transition()
              .delay(700)
              .style("font-size", "18px")
              .style("padding", "2px 5px"),
            [
              pValueSeguridad,
              pValuePolitica,
              pValueTransito,
              pEmpleo,
              pServicios,
            ].map((elm) => elm.style("font-size", "0px")),
            [bubbleEmpleo, bubbleServicios].map((elm) =>
              elm.style("width", "0").style("height", "0")
            )
          );
        case stepBubbles + 3:
          // step en el que las palabras se transforman en pelotitas
          return (
            pServicios.style("font-size", "0").style("padding", "0"),
            pEmpleo.style("font-size", "0").style("padding", "0"),
            [
              pPolitica,
              pSeguridad,
              pTransito,
              pValueSeguridad,
              pValuePolitica,
              pValueTransito,
            ].map((elm) =>
              elm.transition().style("font-size", "0").style("padding", "0")
            ),
            bubblePolitica
              .style(
                "top",
                `${windowWidth < 768 ? bubblesTop + 10 : bubblesTop}%`
              )
              .style("opacity", "1")
              .transition()
              .style("left", `${wordsPosition.politicas}%`)
              .style("width", "30px")
              .style("height", "30px"),
            bubbleSeguridad
              .style(
                "top",
                `${windowWidth < 768 ? bubblesTop + 20 : bubblesTop}%`
              )
              .style("opacity", "1")
              .transition()
              .style("left", `${wordsPosition.seguridad}%`)
              .style("width", "30px")
              .style("height", "30px"),
            bubbleTransito
              .style("opacity", "1")
              .style(
                "top",
                `${windowWidth < 768 ? bubblesTop + 30 : bubblesTop}%`
              )
              .transition()
              .style("left", `${wordsPosition.transito}%`)
              .style("width", "30px")
              .style("height", "30px"),
            [bubbleEmpleo, bubbleServicios].map((elm) =>
              elm.transition().style("width", "0").style("height", "0")
            )
          );
        case stepBubbles + 4: {
          // step en el aparecen todas las pelotitas y se ordenan de manera escalonada
          return (
            bubblePolitica
              .style("opacity", "1")
              .transition()
              .style("top", `${bubblesPositionY.politicas}%`)
              .style("left", `${bubblesPositionX.politicas}px`)
              .style("width", `${bubblesSize.politicas}px`)
              .style("height", `${bubblesSize.politicas}px`),
            bubbleSeguridad
              .style("opacity", "1")
              .transition()
              .style("top", `${bubblesPositionY.seguridad}%`)
              .style("left", `${bubblesPositionX.seguridad}px`)
              .style("width", `${bubblesSize.seguridad}px`)
              .style("height", `${bubblesSize.seguridad}px`),
            bubbleTransito
              .style("opacity", "1")
              .transition()
              .style("top", `${bubblesPositionY.transito}%`)
              .style("left", `${bubblesPositionX.transito}px`)
              .style("width", `${bubblesSize.transito}px`)
              .style("height", `${bubblesSize.transito}px`),
            bubbleEmpleo
              .style("opacity", "1")
              .style("top", `${bubblesPositionY.empleo}%`)
              .style("left", `${bubblesPositionX.empleo}px`)
              .transition()
              .style("opacity", "1")
              .style("width", `${bubblesSize.empleo}px`)
              .style("height", `${bubblesSize.empleo}px`),
            bubbleServicios
              .style("opacity", "1")
              .style("top", `${bubblesPositionY.servicios}%`)
              .style("left", `${bubblesPositionX.servicios}px`)
              .transition()
              .style("opacity", "1")
              .style("width", `${bubblesSize.servicios}px`)
              .style("height", `${bubblesSize.servicios}px`),
            pServicios
              .transition()
              .delay(700)
              .style("font-size", `${bubblesSize.servicios / 3}px`),
            pEmpleo
              .transition()
              .delay(700)
              .style("font-size", `${bubblesSize.empleo / 3}px`),
            [pSeguridad, pPolitica, pTransito].map((elm) =>
              elm.style("font-size", "0px")
            ),
            pValueSeguridad
              .transition()
              .delay(700)
              .style("font-size", `${bubblesSize.seguridad / 3}px`),
            pValuePolitica
              .transition()
              .delay(700)
              .style("font-size", `${bubblesSize.politicas / 3}px`),
            pValueTransito
              .transition()
              .delay(700)
              .style("font-size", `${bubblesSize.transito / 3}px`)
          );
        }
        case stepBubbles + 5: {
          return (
            [pSeguridad, pPolitica, pTransito].map((elm) =>
              elm.style("font-size", "0px")
            ),
            pServicios.style("font-size", `${bubblesSize.servicios / 3}px`),
            pEmpleo.style("font-size", `${bubblesSize.empleo / 3}px`),
            pValueSeguridad.style(
              "font-size",
              `${bubblesSize.seguridad / 3}px`
            ),
            pValuePolitica.style("font-size", `${bubblesSize.politicas / 3}px`),
            pValueTransito.style("font-size", `${bubblesSize.transito / 3}px`)
          );
        }
        default:
          return;
      }
    }
  }, [
    currentStepIndex,
    bubblesContainerHeight,
    bubblesSize,
    initBubblesY,
    marginBetweenBubblesX,
    stepBubbles,
    totalHeight,
    windowWidth,
    wordsPosition.politicas,
    wordsPosition.seguridad,
    wordsPosition.transito,
  ]);

  const { language } = useCurrentLanguage();

  return progress ? (
    <>
      <div
        ref={refContainer}
        style={{
          opacity:
            currentStepIndex < stepBubbles - 1
              ? 0
              : currentStepIndex >= stepBubbles + 1
              ? 1
              : progress.progress !== 1
              ? progress.progress
              : 0,
        }}
        id="bubbles-container"
        className={`w-full flex-col text-black h-full transition-all ${
          currentStepIndex < stepBubbles ? "hidden" : "flex"
        }`}
      >
        <p
          className={`w-full lg:w-2/3 xl:w-full text-base desktop:text-2xl text-dark-grey  font-semibold text-center mx-auto transition-all
              `}
        >
          {TEXT["mixed_feelings"]["step2"]["circles"]["sub_1"][language]}
        </p>
        <p
          className={`w-full lg:w-2/3 xl:w-full text-base desktop:text-2xl text-dark-grey  font-semibold mt-4 mx-auto text-center transition-all duration-500 
             ${
               currentStepIndex >= stepBubbles + 1
                 ? // &&
                   // currentStepIndex <= stepBubbles + 3
                   "opacity-1"
                 : "opacity-0"
             }`}
        >
          {TEXT["mixed_feelings"]["step2"]["circles"]["sub_2"][language]}
        </p>

        <p
          className={`text-base desktop:text-xl mt-4 md:mt-8 xl:mt-4 font-bold text-dark-blue md:w-2/3 mx-auto text-center transition-all duration-500 ${
            currentStepIndex >= stepBubbles + 4
              ? // &&
                // currentStepIndex <= stepBubbles + 3
                "opacity-1"
              : "opacity-0"
          }`}
        >
          {TEXT["mixed_feelings"]["step2"]["circles"]["title"][language]}
        </p>
        <p
          className={`text-base desktop:text-lg md:w-2/3 mx-auto text-center transition-all duration-500 ${
            currentStepIndex >= stepBubbles + 4
              ? // &&
                // currentStepIndex <= stepBubbles + 3
                "opacity-1"
              : "opacity-0"
          }`}
        >
          {TEXT["mixed_feelings"]["step2"]["circles"]["year"][language]} 2026
        </p>
        <div ref={refBubblesContainer} className="h-full relative">
          <div
            className={`opacity-0 bg-${topics.empleo.color} absolute rounded-full flex items-center`}
            id="empleo"
          >
            <p className="mx-auto text-white font-semibold !mb-0">
              {data.find((elm) => elm.id === "empleo").value}%
            </p>
          </div>
          <div
            className={`opacity-0 bg-${topics.servicios.color} absolute rounded-full flex items-center`}
            id="servicios"
          >
            <p className="mx-auto text-white font-semibold !mb-0">
              {data.find((elm) => elm.id === "servicios").value}%
            </p>
          </div>
          <div
            id="politica"
            style={{
              left: "20%",
            }}
            className={`flex rounded-full flex-col justify-center items-center text-white  bg-purple  ${
              currentStepIndex <= stepBubbles + 2 ? "px-2" : "0"
            } absolute py-1 transition-all opacity-0`}
          >
            <p className={`mx-auto label font-semibold !mb-0`}>
              {language === "en" ? "Migration Policy" : "Política migratoria"}
            </p>
            <p className="value mx-auto font-semibold mb-0">
              {data.find((elm) => elm.id === "politicas").value}%
            </p>
          </div>
          <div
            id="seguridad"
            className={`flex flex-col justify-center items-center text-white  bg-dark-blue ${
              currentStepIndex <= stepBubbles + 2 ? "px-2" : "0"
            } rounded-full absolute py-1 transition-all opacity-0`}
          >
            <p className={`label mx-auto font-semibold !mb-0`}>
              {language === "en" ? "Security" : "Seguridad"}
            </p>
            <p className="value mx-auto font-semibold !mb-0">
              {data.find((elm) => elm.id === "seguridad").value}%
            </p>
          </div>
          <div
            id="transito"
            style={{
              left: "70%",
            }}
            className={`flex flex-col justify-center items-center text-white  bg-yellow  rounded-full ${
              currentStepIndex <= stepBubbles + 2 ? "px-2" : "0"
            } absolute py-1 transition-all opacity-0`}
          >
            <p className={`mx-auto label font-semibold !mb-0`}>
              {language === "en" ? "Human Transit" : "Tránsito de personas"}
            </p>
            <p className="value mx-auto font-semibold !mb-0">
              {data.find((elm) => elm.id === "transito").value}%
            </p>
          </div>
        </div>
        <div
          className={`text-dark-grey flex flex-wrap gap-2 md:gap-8 mx-auto mt-auto transition-all duration-500 justify-center md${
            currentStepIndex >= stepBubbles + 4
              ? // &&
                // currentStepIndex <= stepBubbles + 3
                "opacity-1"
              : "opacity-0"
          }`}
        >
          {Object.keys(topics).map((elm, index) => {
           // console.log("elm", elm);
            //console.log("TOPICS", topics[elm]);

            return (
              <div key={`topic-${elm}`} className="flex gap-2 items-center">
                <div
                  className={`bg-${topics[elm].color} h-2 md:h-4 w-2 md:w-4 rounded-full `}
                ></div>
                <p className="text-xs mb-0">
                  {
                    TEXT["mixed_feelings"]["step2"]["circles"]["graph_names"][
                      topics[elm].name
                    ][language]
                  }
                </p>
              </div>
            );
          })}
        </div>
      </div>
    </>
  ) : null;
}
